/**
 * Product gallery image performance:
 * - Mark LCP/eager images as loaded for LQIP fade-in
 * - Prefetch remaining slides after first paint (idle)
 */
(function () {
  function markLoaded(img) {
    if (!img) return;
    img.classList.add('is-loaded');
  }

  function bindLqip(img) {
    if (!img || img.dataset.lqipBound === '1') return;
    img.dataset.lqipBound = '1';

    if (img.complete && img.naturalWidth > 0) {
      markLoaded(img);
      return;
    }

    img.addEventListener('load', () => markLoaded(img), { once: true });
    img.addEventListener('error', () => markLoaded(img), { once: true });
  }

  function pickPrefetchSrc(img) {
    if (!img) return null;
    if (img.currentSrc) return img.currentSrc;

    const srcset = img.getAttribute('srcset');
    if (!srcset) return img.getAttribute('src');

    const candidates = srcset.split(',').map((part) => {
      const [url, width] = part.trim().split(/\s+/);
      return { url, width: parseInt(width, 10) || 0 };
    });
    candidates.sort((a, b) => a.width - b.width);
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const targetWidth = Math.ceil(window.innerWidth * dpr);
    const target = candidates.find((c) => c.width >= targetWidth) || candidates[candidates.length - 1];
    return target?.url || img.getAttribute('src');
  }

  function prefetchUrl(url) {
    if (!url) return;
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'image';
    link.href = url;
    document.head.appendChild(link);
  }

  function enhanceGallery() {
    const list = document.querySelector('.product__media-list');
    if (!list) return;

    const images = Array.from(list.querySelectorAll('.product__media img'));
    images.forEach((img, index) => {
      bindLqip(img);

      if (index === 0) return;

      if (img.loading === 'lazy') {
        img.loading = 'eager';
      }

      const url = pickPrefetchSrc(img);
      if (url) prefetchUrl(url);
    });
  }

  function schedule() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(enhanceGallery, { timeout: 900 });
    } else {
      setTimeout(enhanceGallery, 200);
    }
  }

  // Bind LQIP immediately so first image doesn't stay invisible
  document.querySelectorAll('.product-media--lqip img').forEach(bindLqip);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('.product-media--lqip img').forEach(bindLqip);
      schedule();
    });
  } else {
    schedule();
  }
})();